import { Action } from '@ngrx/store';

import { Address } from '../../models';

export enum AddressesActionTypes {
  ClearAddresses = '[app-checkout/Checkout] Clear addresses',

  ReadAddresses = '[app-checkout/Checkout] Read addresses',
  ReadAddressesSuccess = '[app-checkout/Checkout] Read addresses Success',
  ReadAddressesFailure = '[app-checkout/Checkout] Read addresses Failure',

  CreateAddress = '[app-checkout/Checkout] Create address',
  CreateAddressSuccess = '[app-checkout/Checkout] Create address Success',
  CreateAddressFailure = '[app-checkout/Checkout] Create address Failure',

  CreateAddressBatch = '[app-checkout/Checkout] Create address batch',
  CreateAddressBatchSuccess = '[app-checkout/Checkout] Create address batch Success',
  CreateAddressBatchFailure = '[app-checkout/Checkout] Create address batch Failure',

  UpdateAddress = '[app-checkout/Checkout] Update address',
  UpdateAddressSuccess = '[app-checkout/Checkout] Update address Success',
  UpdateAddressFailure = '[app-checkout/Checkout] Update address Failure',

  SelectBillingAddress = '[app-checkout/Checkout] Select other billing address',
  SelectShippingAddress = '[app-checkout/Checkout] Select other shipping address',

  ReadPreservedAddresses = '[app-checkout/Checkout] Read preserved addresses',
  ReadPreservedSuccess = '[app-checkout/Checkout] Read preserved addresses Success',
  ReadPreservedFailure = '[app-checkout/Checkout] Read preserved addresses Failure',

  RemovePreservedAddress = '[app-checkout/Checkout] Remove preserved addresses',

  UpdateFreightForwarding = '[app-checkout/Checkout] Update freight forwarding',

  UpdatePreservedAddress = '[app-checkout/Checkout] Update preserved address',

  PreserveAddresses = '[app-checkout/Checkout] Preserve addresses',
  PreserveAddressesSuccess = '[app-checkout/Checkout] Preserve addresses Success',
  PreserveAddressesFailure = '[app-checkout/Checkout] Preserve addresses Failure',

  ValidateShippingAddress = '[app-checkout/Checkout] Validate shipping address',
  ValidateShippingAddressSuccess = '[app-checkout/Checkout] Validate shipping address Success',
  ValidateShippingAddressFailure = '[app-checkout/Checkout] Validate shipping address Failure',
}

export class ClearAddresses implements Action {
  readonly type = AddressesActionTypes.ClearAddresses;
}

export class ReadAddresses implements Action {
  readonly type = AddressesActionTypes.ReadAddresses;
}

export class ValidateShippingAddress implements Action {
  readonly type = AddressesActionTypes.ValidateShippingAddress;
  constructor(public payload: [Address, Address]) {}
}

export class ValidateShippingAddressSuccess implements Action {
  readonly type = AddressesActionTypes.ValidateShippingAddressSuccess;
}

export class ValidateShippingAddressFailure implements Action {
  readonly type = AddressesActionTypes.ValidateShippingAddressFailure;
}

export class ReadAddressesSuccess implements Action {
  readonly type = AddressesActionTypes.ReadAddressesSuccess;
  constructor(public payload: Address[]) {}
}

export class ReadAddressesFailure implements Action {
  readonly type = AddressesActionTypes.ReadAddressesFailure;
  constructor(public payload: any) {}
}

export class CreateAddress implements Action {
  readonly type = AddressesActionTypes.CreateAddress;
  constructor(public payload: Address) {}
}

export class CreateAddressSuccess implements Action {
  readonly type = AddressesActionTypes.CreateAddressSuccess;
  constructor(public payload: Address) {}
}

export class CreateAddressFailure implements Action {
  readonly type = AddressesActionTypes.CreateAddressFailure;
  constructor(public payload: any) {}
}

export class CreateAddressBatch implements Action {
  readonly type = AddressesActionTypes.CreateAddressBatch;
  constructor(public payload: { addresses: Address[] }) {}
}

export class CreateAddressBatchSuccess implements Action {
  readonly type = AddressesActionTypes.CreateAddressBatchSuccess;
  constructor(public payload: { addresses: Address[] }) {}
}

export class CreateAddressBatchFailure implements Action {
  readonly type = AddressesActionTypes.CreateAddressBatchFailure;
  constructor(public payload: { error: any }) {}
}

export class UpdateAddress implements Action {
  readonly type = AddressesActionTypes.UpdateAddress;
  constructor(public payload: { address: Address; id: string }) {}
}

export class UpdateAddressSuccess implements Action {
  readonly type = AddressesActionTypes.UpdateAddressSuccess;
  constructor(public payload: Address) {}
}

export class UpdateAddressFailure implements Action {
  readonly type = AddressesActionTypes.UpdateAddressFailure;
  constructor(public payload: any) {}
}

export class ReadPreservedAddresses implements Action {
  readonly type = AddressesActionTypes.ReadPreservedAddresses;
}

export class ReadPreservedAddressesSuccess implements Action {
  readonly type = AddressesActionTypes.ReadPreservedSuccess;
  constructor(public payload: { shipping?: Address; billing?: Address }) {}
}

export class ReadPreservedAddressesFailure implements Action {
  readonly type = AddressesActionTypes.ReadPreservedFailure;
  constructor(public payload: any) {}
}

export class RemovePreservedAddress implements Action {
  readonly type = AddressesActionTypes.RemovePreservedAddress;
  constructor(public payload: any) {}
}

export class UpdateFreightForwarding implements Action {
  readonly type = AddressesActionTypes.UpdateFreightForwarding;
  constructor(public payload: any) {}
}

export class UpdatePreservedAddress implements Action {
  readonly type = AddressesActionTypes.UpdatePreservedAddress;
  constructor(public payload: { shipping: Address; billing: Address; billingAsShipping: boolean }) {}
}

export class PreserveAddress implements Action {
  readonly type = AddressesActionTypes.PreserveAddresses;
  constructor(public payload: { address: Address; type: string }) {}
}

export class PreserveAddressSuccess implements Action {
  readonly type = AddressesActionTypes.PreserveAddressesSuccess;
  constructor(public payload: Address) {}
}

export class PreserveAddressFailure implements Action {
  readonly type = AddressesActionTypes.PreserveAddressesFailure;
  constructor(public payload: any) {}
}

export class SelectBillingAddress implements Action {
  readonly type = AddressesActionTypes.SelectBillingAddress;
  constructor(public payload: Address) {}
}

export class SelectShippingAddress implements Action {
  readonly type = AddressesActionTypes.SelectShippingAddress;
  constructor(public payload: Address) {}
}

export type AddressesActions =
  | ReadAddresses
  | ReadAddressesSuccess
  | ReadAddressesFailure
  | ClearAddresses
  | CreateAddressBatch
  | CreateAddressBatchSuccess
  | CreateAddressBatchFailure
  | CreateAddress
  | CreateAddressSuccess
  | CreateAddressFailure
  | PreserveAddress
  | PreserveAddressSuccess
  | UpdateFreightForwarding
  | PreserveAddressFailure
  | ReadPreservedAddresses
  | ReadPreservedAddressesSuccess
  | ReadPreservedAddressesFailure
  | RemovePreservedAddress
  | UpdatePreservedAddress
  | SelectBillingAddress
  | SelectShippingAddress
  | UpdateAddress
  | UpdateAddressSuccess
  | UpdateAddressFailure
  | ValidateShippingAddress
  | ValidateShippingAddressSuccess
  | ValidateShippingAddressFailure;
